import { useEffect, useState } from "react";

import {
    Button,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
} from "reactstrap";
import { blockMember, changeRole, muteMember } from "../Services/GroupMemberService";


interface Props {

    isOpen: boolean;

    toggle: () => void;

    member: any;

    reload: () => Promise<void>;

}

const MemberManagementModal = ({
    isOpen,
    toggle,
    member,
    reload
}: Props) => {

    const [role, setRole] =
        useState("");

    const [isMuted, setIsMuted] =
        useState(false);

    const [isBlocked, setIsBlocked] =
        useState(false);
    const [reason, setReason] = useState("");
    useEffect(() => {

        if (!member)
            return;

        setRole(member.role);

        setIsMuted(member.isMuted);

        setIsBlocked(member.isBlocked);

        setReason("");

    }, [member]);

    const save = async () => {

        if (role !== member.role) {
            await changeRole(member.groupMemberId, { role });
        }

        if (isMuted !== member.isMuted) {
            await muteMember(member.groupMemberId, {
                isMuted
            });
        }

        if (isBlocked !== member.isBlocked) {

            if (isBlocked && !reason.trim()) {
                alert("Please enter a reason for blocking.");
                return;
            }

            await blockMember(member.groupMemberId, {
                isBlocked,
                reason
            });
        }

        await reload();
        toggle();
    };

    if (!member)
        return null;

    return (

        <Modal
            isOpen={isOpen}
            toggle={toggle}
            centered
            size="md"

        >

            <div
                style={{
                    borderRadius: "18px",
                    overflow: "hidden",
                    background: "#f8fafc",
                }}
            >

                <ModalHeader toggle={toggle}
                    style={{
                        background: "linear-gradient(135deg,#2563eb,#4f46e5)",
                        color: "#fff",
                        padding: "18px 24px",
                        fontWeight: 700,
                        overflow: "hidden",
                        fontSize: "22px",
                    }}>

                    Member Management

                </ModalHeader>

                <ModalBody>

                    <h5>

                        {member.userName}

                    </h5>

                    <FormGroup>

                        <Label>

                            Role

                        </Label>

                        <Input
                            type="select"
                            value={role}
                            onChange={(e) =>
                                setRole(e.target.value)
                            }
                        >

                            <option value="Member">

                                Member

                            </option>

                            <option value="Coordinator">

                                Coordinator

                            </option>

                        </Input>

                    </FormGroup>

                    <FormGroup
                        check
                        className="mb-3"
                    >

                        <Input
                            type="checkbox"
                            checked={isMuted}
                            onChange={(e) =>
                                setIsMuted(
                                    e.target.checked
                                )
                            }
                        />

                        <Label check>

                            Mute Member

                        </Label>

                    </FormGroup>

                    <FormGroup check>

                        <Input
                            type="checkbox"
                            checked={isBlocked}
                            onChange={(e) =>
                                setIsBlocked(e.target.checked)
                            }
                        />

                        <Label check>

                            Block Member

                        </Label>

                    </FormGroup>

                    {isBlocked && (

                        <FormGroup className="mt-3">

                            <Label>

                                Reason for Blocking

                            </Label>

                            <Input
                                type="textarea"
                                rows={3}
                                placeholder="Enter reason for blocking..."
                                value={reason}
                                onChange={(e) =>
                                    setReason(e.target.value)
                                }
                            />

                        </FormGroup>

                    )}

                </ModalBody>

                <ModalFooter>

                    <Button
                        color="secondary"
                        onClick={toggle}
                    >

                        Cancel

                    </Button>

                    <Button
                        color="primary"
                        onClick={save}
                    >

                        Save Changes

                    </Button>

                </ModalFooter>
            </div>


        </Modal>

    );

};

export default MemberManagementModal;